const HELP_TEXTS = {
  budgetDetails: {
    grossOfferValue:
      'Gross Budget to be spent across all channels that includes discounts, free services and co-invests (if any). This is the value that will be delivered to your client (exceptions: Media Offsite products).',
    freeServiceValue:
      'Discounts in terms of Free, not to be paid service value across different products. Only available for certain products.',
    feeDiscount:
      'Discount in terms of budget shifted from our management fee, into the actual media acquisition. Our management fee is reduced by this amount if an amount is given during the quote creation.',
    coInvest:
      'Co-Invest is the amount of budget that is invested by Zalando (Category Management, Markets, Marketing). This amount needs to be invoiced to Zalando.',
    headerDiscount:
      'Different from Free Media and Co-invest, a Header Discount is added on top of Gross Revenue.',
    netClientBudget:
      'This is the sum of the External and WKZ budget that BI will use.',
    targetKpiValue: 'The target (min / max) value for the defined target KPI.',
    campaignDates: 'Planned or assumed dates of the services / campaign.',
    categories:
      'A list of categories the campaign should be set up for. These categories are an abstract list of categories and will be translated into specific shop URL keys later in the process.',
    genders: 'A gender (combination) the campaign should be set up for.',
    purchaseOrderNumber:
      'A Purchase Order Number in case the clients needs this for their internal accounting processes.',
    flexibilityTerms:
      'Full flexibility stands for all optimizations that can be done by AdOps without consulting the brand or the (S)PCs. Limited Flexibility allows (S)PCs to select certain actions that AdOps is allowed to make.',
    allowedFlexibilities:
      'In case the Flexibility Term is Semi Flexibility, AdOps can make optimizations based on the input here, without consulting the (S)PCs.',
    owner:
      'This is a read-only field. It can only be changed in the Opportunity screen.',
    comment:
      'Any additional comment that is needed for the IO document, i.e. description of any necessary side agreements.',
    additionalDetails:
      'When Discretionary Media is selected as Commercial Incentive, please fill this in.',
  },
  download: {
    missingPrimaryContact:
      'Please select a primary contact first to use this feature.',
    missingSecondaryContact:
      'Please select/update the secondary contact. The contact should have a first name, last name and email to use this feature.',
    quoteEditor:
      'Make sure to save your changes before downloading or sending the quote, so nothing gets lost.',
  },
  onsiteAverage: {
    dailyRate:
      'This is an estimation of what the daily spend should be for Onsite Placements based on the Runtime and Spendable Budget.',
  },
  productsTable: {
    priceModel:
      'The selected pricing model (CPC, CPV, ...) for the given product.',
    netClientBudgetExternal:
      'This is the budget that will be invoiced to the client.',
    wkzBudget:
      'This is the WKZ budget that will be invoiced to the WKZ cost center.',
    freeService:
      'Free Service for the given product. Only available for certain products.',
    adjustedFee:
      'The service fee for the given product. Not all products have a service fee (e.g. Onsite Placements). Reducing the Management Fee is considered as giving a discount.',
    spendableBudget:
      'The actual resulting Service Value for the given product ,based on the Net Client Budget, Co-Invest, Header Discount, Management Fee, and Free Service.',
    countrySplit:
      'The split of service value for the given product across countries for Onsite and Offsite placements.',
  },
  tooltips: {
    disabledCcpCampaign:
      'This ad type is not editable, make sure to finalize the campaign briefing in Ad Manager',
    zmsAmCountriesNotSupported:
      'Countries not supported for this product. This can be configured in the downstream system',
  },
};

export default HELP_TEXTS;
